import React from "react";
import Select, { components } from "react-select";
import Search from "../../Header/Search/Search";
import ManageAssetList from "../../Assets/AssetList/ManageAssetList";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <span className="ico-down text-blue-600"></span>
    </components.DropdownIndicator>
  );
};

const ManageAsset = () => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between px-10 pb-4 mt-8">
        <div>
          <h2>Manage Assets</h2>
          <p>Manage assets</p>
        </div>
        <div>
          <a href="" className="btn text-[14px]">
            <span>
              <i className="ico-plus text-white mr-1"></i>
            </span>
            Add New Asset
          </a>
        </div>
      </div>
      <div className="flex justify-between items-center px-10 pb-4">
        <div className="flex gap-3">
          <Select
            options={[
              { value: "All", label: "All" },
              { value: "27 Apr 2022", label: "27 Apr 2022" },
              { value: "27 Apr 2022", label: "27 Apr 2022" },
              { value: "27 Apr 2022", label: "27 Apr 2022" }
            ]}
            components={{ DropdownIndicator }}
            className="custom-select-container text-gray-500"
            defaultValue={{
              value: "Added Date: All",
              label: "Added Date: All"
            }}
          />
          <Select
            options={[
              { value: "All", label: "All" },
              { value: "Laptop", label: "Laptop" },
              { value: "Computer", label: "Computer" }
            ]}
            components={{ DropdownIndicator }}
            className="custom-select-container text-gray-500"
            defaultValue={{
              value: "Type: All",
              label: "Type: All"
            }}
          />
          <Select
            options={[
              { value: "All", label: "All" },
              {
                value: "Available",
                label: "Available"
              },
              { value: "Out Of Stock", label: "Out Of Stock" }
            ]}
            components={{ DropdownIndicator }}
            className="custom-select-container text-gray-500"
            defaultValue={{
              value: "Status:All",
              label: "Status:All"
            }}
          />
        </div>
        <div className="flex">
          <div>
            <Search />
          </div>
          <a href="" className="btn btn--border text-[14px]">
            <span>
              <i className="ico-download mr-1"></i>
            </span>
            Download
          </a>
        </div>
      </div>
      <div>
        <ManageAssetList />
      </div>
    </div>
  );
};

export default ManageAsset;
